const swiper = new Swiper(".testimonials__slider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true,
     autoplay: {
        delay: 7500,
        disableOnInteraction: false,
      },
    spaceBetween: 24,
    slidesPerView: 1,
    breakpoints: {
        800: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
  });